export const AnnotationType = {
    CLASS_PREPARATION: 'class_preparation',
    ACTIVITY: 'activity',
    INTERACTIVE_OBJECT: 'interactive_object',
    ONE_TUTOR: 'one_tutor',
    ONE_CLASS: 'one_class',
    GUEST: 'guest',
};
